<template>
  <DynamicScroller
    v-if="clientData.notifications.length > 0"
    key="notifications-container"
    v-slot="{ item, active, index }"
    class="scroller"
    :items="clientData.notifications"
    :min-item-size="80"
    :buffer="50"
    key-field="id"
    @scroll-end="updateScrollEnd"
  >
    <DynamicScrollerItem
      :key="item.id"
      :item="item"
      watch-data
      :active="active"
      :data-index="index"
    >
      <BroadcastCard
        v-if="item?.detail?.__typename === 'BroadcastMessageEventDetails'"
        :source="item"
        :active="active"
        :handle-select-detail="handleSelectDetail"
        :index="index"
      />
      <GenericEventCard
        v-else-if="item?.detail?.__typename === 'GenericEventDetails'"
        :source="item"
        :active="active"
        :handle-select-detail="handleSelectDetail"
        :index="index"
      />
    </DynamicScrollerItem>
  </DynamicScroller>
  <empty-alert-history v-else />
</template>

<script lang="ts">
import { useNotifiStore } from '../../../stores';

import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import { defineComponent } from 'vue';
import { storeToRefs } from 'pinia';
import {
  GenericEventCard,
  BroadcastCard,
  EmptyAlertHistory,
} from '../../components/';
import { Types } from '@notifi-network/notifi-graphql';

const notifiStore = useNotifiStore();
export default defineComponent({
  name: 'AlertHistory',
  components: {
    EmptyAlertHistory,
    DynamicScroller,
    BroadcastCard,
    GenericEventCard,
    DynamicScrollerItem,
  },
  emits: ['onDetailSelected'],
  data() {
    const { clientData } = storeToRefs(notifiStore);

    return {
      scrollEnd: false,
      clientData,
    };
  },
  watch: {
    scrollEnd(isScrollEnd) {
      if (isScrollEnd) {
        notifiStore.fetchNotificationsPage();
        this.scrollEnd = false;
      }
    },
  },
  methods: {
    updateScrollEnd() {
      this.scrollEnd = true;
    },
    handleSelectDetail(
      sourceItem?: Types.NotificationHistoryEntryFragmentFragment,
    ) {
      this.$emit('onDetailSelected', sourceItem ?? undefined);
    },
  },
});
</script>

<style lang="scss" scoped>
.scroller {
  margin-bottom: 44px;
  height: 100%;
}
</style>
